module.exports = __webpack_public_path__ + "static/media/53.6ac5dd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/53.png
// module id = 478
// module chunks = 0